<div class="container">
	<!-- Nombre del proyecto -->
	<div id="nombreProyecto" class="input-group">
		<span class="input-group-text" id="projectName">{{
			modelService.getString("builder_project_name")
		}}</span>
		<input
			type="text"
			class="form-control"
			aria-label="Username"
			[(ngModel)]="projectData.nombre"
			aria-describedby="projectName"
		/>
	</div>

	<p class="Labels">{{ modelService.getString("conf_producto") }}</p>

	<button
		id="idBtnCercados"
		type="button"
		(click)="panelProductos(1)"
		class="btn cercadoFamilia"
	>
		<div class="d-flex justify-content-between">
			<div>{{ familiaCercadoTitulo }}</div>
			<div class="actualCercado">{{ cercadoNombre }}</div>
		</div>
	</button>
	<div id="idCercados" [class]="classCercados">
		<div class="fotosCercados">
			<div class="fotoCercado"></div>
			<div [ngClass]="actualModelo('LUX_EST')">
				<img
					src="./assets/img/catalog/LUX_EST.jpg"
					alt="LUX EST"
					(click)="selectCercado('LUX_EST')"
				/>
				<span>LUX EST</span>
			</div>
			<div [ngClass]="actualModelo('LUX_ELECTRO')">
				<img
					src="./assets/img/catalog/LUX_ELECTRO.jpg"
					alt="LUX ELECTRO"
					(click)="selectCercado('LUX_ELECTRO')"
				/>
				<span>LUX ELECTRO</span>
			</div>
			<div [ngClass]="actualModelo('LUX_ANUDADA')">
				<img
					src="./assets/img/catalog/LUX_ANUDADA.jpg"
					alt="LUX ANUDADA"
					(click)="selectCercado('LUX_ANUDADA')"
				/>
				<span>LUX ANUDADA</span>
			</div>
		</div>
	</div>

	<button
		id="idBtnVerjas"
		type="button"
		(click)="panelProductos(2)"
		class="btn verjaFamilia"
	>
		<div class="d-flex justify-content-between">
			<div>{{ familiaVerjaTitulo }}</div>
			<div class="actualVerja">{{ verjaNombre }}</div>
		</div>
	</button>
	<div id="idVerjas" [class]="classVerjas">
		<div class="fotosVerjas">
			<div [ngClass]="actualModelo('BRICO-FAX')">
				<img
					src="./assets/img/catalog/BRICO-FAX.jpg"
					alt="BRICO FAX"
					(click)="selectVerja('BRICO-FAX')"
				/>
				<span>BRICO FAX</span>
			</div>
			<div [ngClass]="actualModelo('FAX')">
				<img
					src="./assets/img/catalog/FAX.jpg"
					alt="FAX"
					(click)="selectVerja('FAX')"
				/>
				<span>FAX</span>
			</div>
			<div [ngClass]="actualModelo('FAX DH')">
				<img
					src="./assets/img/catalog/FAX DH.jpg"
					alt="FAX DH"
					(click)="selectVerja('FAX DH')"
				/>
				<span>FAX DH</span>
			</div>
			<div [ngClass]="actualModelo('MAXI-FAX')">
				<img
					src="./assets/img/catalog/MAXI-FAX.jpg"
					alt="MAXI FAX"
					(click)="selectVerja('MAXI-FAX')"
				/>
				<span>MAXI FAX</span>
			</div>
			<div [ngClass]="actualModelo('RITMO')">
				<img
					src="./assets/img/catalog/RITMO.jpg"
					alt="RITMO"
					(click)="selectVerja('RITMO')"
				/>
				<span>RITMO</span>
			</div>
			<div [ngClass]="actualModelo('RITMO DH')">
				<img
					src="./assets/img/catalog/RITMO DH.jpg"
					alt="RITMO DH"
					(click)="selectVerja('RITMO DH')"
				/>
				<span>RITMO DH</span>
			</div>
			<div [ngClass]="actualModelo('RITMOCLIP')">
				<img
					src="./assets/img/catalog/RITMOCLIP.jpg"
					alt="RITMOCLIP"
					(click)="selectVerja('RITMOCLIP')"
				/>
				<span>RITMO CLIP</span>
			</div>
		</div>
		<div class="fotosVerjas">
			<div class="fotoVerja"></div>
			<div [ngClass]="actualModelo('CLASSIC')">
				<img
					src="./assets/img/catalog/CLASSIC.jpg"
					alt="CLASSIC"
					(click)="selectVerja('CLASSIC')"
				/>
				<span>CLASSIC</span>
			</div>
			<div [ngClass]="actualModelo('CALITAX')">
				<img
					src="./assets/img/catalog/CALITAX.jpg"
					alt="CALITAX"
					(click)="selectVerja('CALITAX')"
				/>
				<span>CALITAX</span>
			</div>
			<div [ngClass]="actualModelo('NOVE')">
				<img
					src="./assets/img/catalog/NOVE.jpg"
					alt="NOVE"
					(click)="selectVerja('NOVE')"
				/>
				<span>NOVÉ</span>
			</div>
			<div [ngClass]="actualModelo('ULTRA')">
				<img
					src="./assets/img/catalog/ULTRA.jpg"
					alt="ULTRA"
					(click)="selectVerja('ULTRA')"
				/>
				<span>ULTRA</span>
			</div>
			<div [ngClass]="actualModelo('DECOR')">
				<img
					src="./assets/img/catalog/DECOR.jpg"
					alt="DECOR"
					(click)="selectVerja('DECOR')"
				/>
				<span>DECOR</span>
			</div>
			<div [ngClass]="actualModelo('NATURE')">
				<img
					src="./assets/img/catalog/NATURE.jpg"
					alt="NATURE"
					(click)="selectVerja('NATURE')"
				/>
				<span>NATURE</span>
			</div>
		</div>
	</div>
</div>

<div class="row pdfContainer">
	<div
		class="col-sm-3 pdf-download"
		[class.enabled]="getModelo()"
		(click)="downloadModelPDF()"
	>
		<i class="fa fa-file-pdf-o"></i>
		{{ modelService.getString("pdf_download") }}
	</div>
	<div class="col-sm-9"></div>
</div>

<!-- ______________________________________________________ CERCADO ________________________________________________ -->
<div *ngIf="UIisCERCADO()" class="row configuracion">
	<div class="col-lg-3">
		<label for="optMedidaMalla">{{
			modelService.getString("builder_mesh_type")
		}}</label>
		<select
			class="custom-select"
			id="optMedidaMalla"
			[disabled]="listadoTiposPanel.length === 0 || isDisabled"
			[(ngModel)]="idTipoPanel"
			(ngModelChange)="recuperaPaneles()"
		>
			<option [ngValue]="undefined">{{ textSelectMeshCercado() }}</option>
			<option
				*ngFor="let tipoPanel of listadoTiposPanel"
				[ngValue]="tipoPanel._id"
			>
				{{ tipoPanel.desc[modelService.getLanguage().currentLanguage] }}
			</option>
		</select>
	</div>
	<div class="col-lg-3 no-gutters">
		<label for="optAlturaCercado">{{
			modelService.getString("builder_product_height")
		}}</label>
		<select
			class="custom-select mb-2 mr-sm-2 mb-sm-0"
			id="optAlturaCercado"
			[disabled]="listadoPaneles.length === 0 || isDisabled"
			[(ngModel)]="idPanel"
			(ngModelChange)="seleccionaPanel()"
		>
			<option [ngValue]="undefined">
				{{ modelService.getString("builder_product_height_select") }}
			</option>
			<option *ngFor="let panel of listadoPaneles" [ngValue]="panel._id">
				{{ panel.altura }}
			</option>
		</select>
	</div>
	<div *ngIf="posteSeleccionable()" class="col-lg-3 no-gutters">
		<label for="optAlturaCercado">{{
			modelService.getString("product_picker_TypePost")
		}}</label>
		<select
			class="custom-select mb-2 mr-sm-2 mb-sm-0"
			id="optAnchuraPoste"
			[disabled]="isDisabled"
			[(ngModel)]="data.anchuraPoste"
			(ngModelChange)="seleccionaBayoneta()"
		>
			<option value="LUX50">LUX 50mm</option>
			<option value="LUX80">LUX 80mm</option>
		</select>
	</div>
	<div *ngIf="this.listadoBayonetas.length > 0" class="col-lg-2 no-gutters">
		<label>{{ modelService.getString("builder_bayonet_select") }}</label>
		<div class="form-inline bayo-radios">
			<label for="bayo_radio">{{
				modelService.getString("builder_bayonet_type_no")
			}}</label>
			<input
				type="radio"
				id="bayo_radio"
				name="bayo"
				[disabled]="isDisabled"
				[value]="tiposBayoneta.no"
				[(ngModel)]="data.tipoBayoneta"
				(ngModelChange)="seleccionaBayoneta()"
			/>
			<label for="bayo_radio">{{
				modelService.getString("builder_bayonet_type_simple")
			}}</label>
			<input
				type="radio"
				id="bayo_radio"
				name="bayo"
				[disabled]="isDisabled"
				[value]="tiposBayoneta.simple"
				[(ngModel)]="data.tipoBayoneta"
				(ngModelChange)="seleccionaBayoneta()"
			/>
		</div>
	</div>
	<div class="col-lg-1 fontColor no-gutters" style="margin: 0px">
		<label> {{ modelService.getString("builder_color") }} </label>
		<div class="color-picker">
			<div
				class="color-item current"
				[class.disabled]="true"
				[ngStyle]="{ 'background-color': data.hexColor }"
			></div>
		</div>
	</div>
</div>
<!-- ______________________________________________________ VERJA ________________________________________________ -->
<div *ngIf="UIisVERJA()" class="row configuracion">
	<div class="col-lg-3 col-sm-6">
		<label for="optMedidaVerja">{{
			modelService.getString("product_picker_MeasureGate")
		}}</label>
		<select
			class="custom-select"
			id="optMedidaVerja"
			[disabled]="listadoTiposPanel.length === 0 || isDisabled"
			[(ngModel)]="idTipoPanel"
			(ngModelChange)="recuperaPaneles()"
		>
			<option [ngValue]="undefined">{{ textSelectMeshVerja() }}</option>
			<option
				*ngFor="let tipoPanel of listadoTiposPanel"
				[ngValue]="tipoPanel._id"
			>
				{{ tipoPanel.desc[modelService.getLanguage().currentLanguage] }}
			</option>
		</select>
	</div>

	<div class="col-lg-2 col-sm-6" *ngIf="ShowDimensions()">
		<label for="lblDimensiones">{{
			modelService.getString("product_picker_PanelDimensions")
		}}</label>
		<input
			type="text"
			class="inputInfo"
			readonly
			[value]="Dimensiones()"
			id="lblDimensiones"
		/>
	</div>
	<!-- ESPRIVISA-74 -->
	<div class="col-lg-3 col-sm-6">
		<label for="lblTipoPoste">{{
			modelService.getString("product_picker_TypePost")
		}}</label>
		<!-- <input type="text" class="inputInfo" readonly [value]="TipoPoste()" id="lblTipoPoste"> -->
		<!--input type="text" *ngIf = "arrayPostes.length<2" class="inputInfo" readonly [value]="valorPoste()" id="lblTipoPoste"-->
		<select
			class="custom-select"
			id="selectTipoPoste"
			(change)="recogerPoste($event)"
		>
			<option *ngIf="data.tipoPoste == ''" [value]="undefined">
				{{ modelService.getString("post_selection") }}
			</option>
			<option
				*ngIf="data.tipoPoste != ''"
				[value]="data.tipoPoste"
				selected="data.tipoPoste"
			>
				{{ data.tipoPoste }}
			</option>
			<option
				*ngFor="let poste of arrayPostes"
				[ngValue]="poste"
				[value]="poste"
			>
				{{ poste }}
			</option>
		</select>
	</div>
	<!-- ESPRRIVISA-150 -->
	<div class="col-lg-3 col-sm-6" *ngIf="data.modelo.idUnity === 'ULTRA'">
		<label for="lblTopEdgeCut">{{
			modelService.getString("product_picker_topEdgeCut")
		}}</label>
		<select
			class="custom-select"
			id="selectTopEdgeCut"

			[(ngModel)]="data.topEdgeCut"
			(change)="getTopEdgeCut($event)"


		>

		<option
			*ngFor="let cut of TopEdgeCutValuesAndText"
			[value]="cut.value"
		>
			{{ modelService.getString(cut.text) }}
		</option>
			
		</select>
	</div>
	<!-- ESPRIVISA - 74 -->
	<div class="col-lg-1">
		<div class="col-lg-1 fontColor no-gutters" style="margin: 0px">
			<label> {{ modelService.getString("builder_color") }} </label>
			<div class="color-picker">
				<div
					*ngIf="projectData.estado === 0"
					class="color-item current"
					[class.disabled]="false"
					[ngStyle]="{ 'background-color': data.hexColor }"
					(click)="coloresRivisa.Show(true)"
				></div>
				<div
					*ngIf="projectData.estado !== 0"
					class="color-item current"
					[class.disabled]="true"
					[ngStyle]="{ 'background-color': data.hexColor }"
				></div>
			</div>
		</div>
	</div>

	<div *ngIf="this.listadoBayonetas.length > 0" class="col-lg-3 no-gutters">
		<label>{{ modelService.getString("builder_bayonet_select") }}</label>
		<div class="form-inline bayo-radios">
			<label for="bayo_radio">{{
				modelService.getString("builder_bayonet_type_no")
			}}</label>
			<input
				type="radio"
				id="bayo_radio"
				name="bayo"
				[disabled]="isDisabled"
				[value]="tiposBayoneta.no"
				[(ngModel)]="data.tipoBayoneta"
				(ngModelChange)="seleccionaBayonetaVerja()"
			/>
			<label for="bayo_radio">{{
				modelService.getString("builder_bayonet_type_simple")
			}}</label>
			<input
				type="radio"
				id="bayo_radio"
				name="bayo"
				[disabled]="isDisabled"
				[value]="tiposBayoneta.simple"
				[(ngModel)]="data.tipoBayoneta"
				(ngModelChange)="seleccionaBayonetaVerja()"
			/>
			<label *ngIf="canDouble" for="bayo_radio">{{
				modelService.getString("builder_bayonet_type_double")
			}}</label>
			<input
				*ngIf="canDouble"
				type="radio"
				id="bayo_radio"
				name="bayo"
				[disabled]="isDisabled"
				[value]="tiposBayoneta.doble"
				[(ngModel)]="data.tipoBayoneta"
				(ngModelChange)="seleccionaBayonetaVerja()"
			/>
		</div>
	</div>
</div>

<!-- ____________________________________________________________________________________________________ -->
<app-color #coloresRivisa></app-color>
